// 企业大数据
import EnterpriseBigData from '../view/EnterpriseBigData/EnterpriseBigData/EnterpriseBigData'
import EnterpriseBigDataDetail from '../view/EnterpriseBigData/EnterpriseBigData/EnterpriseBigDataDetail'
import EnterpriseParkData from '../view/EnterpriseBigData/EnterpriseParkData/EnterpriseParkData'
import EnterpriseParkDataDetail from '../view/EnterpriseBigData/EnterpriseParkData/EnterpriseParkDataDetail'
import CorporatePortrait from '../view/EnterpriseBigData/CorporatePortrait/CorporatePortrait'
import EnterpriseBigDataNav from '../view/EnterpriseBigData/EnterpriseBigDataNav'

export default [
    /* 企业大数据 */
    {
        path: '/enterprise_big_data',
        name: 'enterprise-big-data',
        components: {
            default: EnterpriseBigDataNav,
            a: EnterpriseBigData
        }
    },
    {
        path: '/enterprise_big_data_detail',
        name: 'enterprise-big-data-detail',
        components: {
            default: EnterpriseBigDataNav,
            a: EnterpriseBigDataDetail
        }
    },
    {
        path: '/enterprise_park_data',
        name: 'enterprise-park-data',
        components: {
            default: EnterpriseBigDataNav,
            a: EnterpriseParkData
        }
    },
    {
        path: '/enterprise_park_data_detail',
        name: 'enterprise-park-data-detail',
        components: {
            default: EnterpriseBigDataNav,
            a: EnterpriseParkDataDetail
        }
    },
    {
        path: '/corporate_portrait/:id',
        name: 'corporate-portrait',
        component: CorporatePortrait
    },
    /* 企业大数据 */
]


// WEBPACK FOOTER //
// ./src/router/EnterpriseBigData.js